export function trackEvent (data) {
  if (typeof window.dataLayer === 'undefined') {
    return false
  }

  window.dataLayer.push(data)
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js